var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"normal-btn",attrs:{"color":_vm.color,"block":_vm.block,"x-large":"","depressed":""},on:{"click":_vm.onLogout}},[_vm._v(" Salir ")])
}
var staticRenderFns = []

export { render, staticRenderFns }